// extracted by mini-css-extract-plugin
export default {"sponsorsContainer":"sponsors_sponsorsContainer__2eOBU","sponsorImg":"sponsors_sponsorImg__TPanh","sponsorsContainerFlex":"sponsors_sponsorsContainerFlex__ZkI4h"};